import styled from 'styled-components/macro'

export const HostessWrapper = styled.div`
	height: 100%;
`
